import { inject, injectable } from "@theia/core/shared/inversify";
import { DebugConsoleContribution } from "@theia/debug/lib/browser/console/debug-console-contribution";
import { DebugFrontendApplicationContribution } from '@theia/debug/lib/browser/debug-frontend-application-contribution';
import { DebugSessionManager } from "@theia/debug/lib/browser/debug-session-manager";

@injectable()
export class RenesasDebugConsoleContribution extends DebugFrontendApplicationContribution {
    @inject(DebugConsoleContribution)
    protected readonly console: DebugConsoleContribution;

    @inject(DebugSessionManager)
    protected readonly manager: DebugSessionManager;

    async onStart(): Promise<void> {
        this.manager.onWillStartDebugSession(() => {
            // Open the debug console when a debug session is triggered
            this.console.openView({ reveal: true, activate: false });
        });
        return super.onStart();
    }
}